
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 35V13a3 3 0 013-3h22a3 3 0 013 3v22a3 3 0 01-3 3H13a3 3 0 01-3-3zm22.22-8.78l-7.69-7.69a.75.75 0 00-1.06 0l-7.69 7.69a.75.75 0 00.53 1.28h15.38a.75.75 0 00.53-1.28z","fill":"#535353","fill-rule":"nonzero"}})])
          )
        }
      }
    